(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["id-discover-latest"] && !Shopify.designMode) return;
  try {
    
  // incrediDeals · Discover Latest — bundled once, initialises every carousel.
  (function () {
    function initDiscoverLatest(root) {
      if (!root || root.dataset.bscInit === '1') return;
      root.dataset.bscInit = '1';

      var track = root.querySelector('[data-bsc-track]');
      if (!track) return;

      var isRtl = root.getAttribute('dir') === 'rtl' || getComputedStyle(root).direction === 'rtl';
      var shouldShuffle = track.hasAttribute('data-bsc-shuffle');

      var cards = Array.prototype.slice.call(track.querySelectorAll('[data-bsc-card], .id-bsc__card'));

      if (shouldShuffle && cards.length > 1) {
        for (var i = cards.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = cards[i]; cards[i] = cards[j]; cards[j] = tmp;
        }
        var frag = document.createDocumentFragment();
        cards.forEach(function (c) { frag.appendChild(c); });
        track.appendChild(frag);
      }

      var prev = root.querySelector('[data-bsc-prev]');
      var next = root.querySelector('[data-bsc-next]');

      function step() {
        var c = track.querySelector('[data-bsc-card], .id-bsc__card');
        if (!c) return 300;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        return c.getBoundingClientRect().width + gap;
      }

      function update() {
        var sl = track.scrollLeft;
        var max = track.scrollWidth - track.clientWidth - 1;
        var atStart, atEnd;
        if (isRtl) { atStart = sl >= -1; atEnd = sl <= -max + 1; }
        else { atStart = sl <= 0; atEnd = sl >= max; }
        if (prev) prev.disabled = atStart;
        if (next) next.disabled = atEnd;
      }

      function go(direction) {
        var amount = step() * 2 * direction;
        if (isRtl) amount = -amount;
        track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      var navFrame=0;
      function scheduleNav(){if(!navFrame)navFrame=requestAnimationFrame(function(){navFrame=0;update();});}
      if(prev||next){track.addEventListener('scroll',scheduleNav,{passive:true});window.addEventListener('resize',scheduleNav);update();}
      document.addEventListener('shopify:section:unload',function(e){if(e.target.contains(root)){window.removeEventListener('resize',scheduleNav);track.removeEventListener('scroll',scheduleNav);cancelAnimationFrame(navFrame);}});


      /* ═══ SPOTLIGHT AUTO-CYCLE ═══ */
      var spotlightOn = root.hasAttribute('data-bsc-spotlight');
      var prefersReduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!spotlightOn || prefersReduce || cards.length === 0) return;

      var speed = parseInt(root.getAttribute('data-bsc-spotlight-speed'), 10) || 3000;
      var timer = null;
      var pauseUntil = 0;
      var hoveredCard = null;

      function visibleCards() {
        var tr = track.getBoundingClientRect();
        var pad = 4;
        return cards.filter(function (c) {
          var r = c.getBoundingClientRect();
          var center = r.left + r.width / 2;
          return center >= (tr.left - pad) && center <= (tr.right + pad);
        });
      }
      function clearAll() {
        for (var i = 0; i < cards.length; i++) cards[i].classList.remove('is-spotlight');
      }
      function setSpotlight(card) {
        if (!card || card.classList.contains('is-spotlight')) return;
        clearAll();
        card.classList.add('is-spotlight');
      }
      function tick() {
        if (Date.now() < pauseUntil || hoveredCard) return;
        var v = visibleCards();
        if (v.length === 0) return;
        var currentIdx = -1;
        for (var i = 0; i < v.length; i++) {
          if (v[i].classList.contains('is-spotlight')) { currentIdx = i; break; }
        }
        setSpotlight(v[(currentIdx + 1) % v.length]);
      }
      function start() {
        if (timer) clearInterval(timer);
        timer = setInterval(tick, speed);
      }

      setTimeout(function () {
        var v = visibleCards();
        if (v.length > 0) setSpotlight(v[0]);
        start();
      }, 600);

      cards.forEach(function (c) {
        c.addEventListener('mouseenter', function () { hoveredCard = c; setSpotlight(c); });
        c.addEventListener('mouseleave', function () {
          if (hoveredCard === c) hoveredCard = null;
          pauseUntil = Date.now() + 800;
        });
      });

      var scrollPauseTimer = null;
      track.addEventListener('scroll', function () {
        pauseUntil = Date.now() + 1500;
        clearTimeout(scrollPauseTimer);
        scrollPauseTimer = setTimeout(function () {
          if (!hoveredCard) { var v = visibleCards(); if (v.length > 0) setSpotlight(v[0]); }
        }, 400);
      }, { passive: true });

      track.addEventListener('touchstart', function () { pauseUntil = Date.now() + 2000; }, { passive: true });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { if (timer) { clearInterval(timer); timer = null; } }
        else if (!timer) { start(); }
      });
    }

    function initAll() {
      var roots = document.querySelectorAll('.id-bsc');
      for (var i = 0; i < roots.length; i++) initDiscoverLatest(roots[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Shopify theme editor: initialise a section when it is (re)loaded.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('.id-bsc') : null;
      if (root) initDiscoverLatest(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
